import { defineComponent as _defineComponent } from 'vue'
import { date } from '@/admin-shared-modules/utils/format'
import { LibAppType } from '@/consts'
import _ from 'lodash'
import Edit from './lib-edit.component.vue'
import Search from './lib-search.component.vue'
import store from './lib.store'


export default /*#__PURE__*/_defineComponent({
  __name: 'lib.component',
  setup(__props) {

const _include = _.includes

const { list } = store

store.list.fetch({ reset: true })
store.libTemplate.fetchAll()

function libTypeName(value) {
  //@ts-ignore
  return (
    _.chain(store.libTemplate.options)
      .find({ key: value })
      // @ts-ignore
      .get('value')
      .value()
  )
}

function handleCurrentChange(index) {
  list.index = index
  store.list.fetch()
}
function onAddClick() {
  store.edit.onAdd()
}
function onEditClick(item) {
  store.edit.onEdit(item)
}
async function onRemoveClick(item) {
  store.edit.onRemove(item)
}

return { __sfc: true,_include, list, libTypeName, handleCurrentChange, onAddClick, onEditClick, onRemoveClick, date, LibAppType, _, Edit, Search }
}

})